import Subject from "../cse4sub/Subject";
import React from 'react'
import cse303m from '../assets/CSE303mid21.pdf'
import cse303e from '../assets/CSE303end21.pdf'

export default function De() {
  return (
    <div>
       <Subject title="Digital Electronics(CSE303)"
    book1="Digital Design, 4th Edition, M. Morris Mano and Michael D. Ciletti, published by Pearson 
    Education, Inc., Copyright © 2007. "
     book2="Fundamental of Digital Circuits, 4th Edition, A. Anand Kumar, published by PHI Learning 
     Private Limited, Copyright © 2016 "
    book1Link="https://www.pdfdrive.com/download.pdf?id=34332016&h=f02c53c86db2a5531cfea4113dfa7f74&u=cache&ext=pdf" 
    book2Link="https://drive.google.com/file/d/1U08V91XzyxJDY7vs5ctnGL-u3Fk5JOr4/view" 
    int21="#" mid21={cse303m} end21={cse303e}
     int20="#" mid20="#" end20="#" mid="Q. Paper"
    />
    </div>
  )
}